import { configureStore } from '@reduxjs/toolkit'
import projectStore from './project-state'
import userStore from './user-state'
import modalsStore from './modals'
import drawerStore from './drawer'
import connectStore from './connect-state'
import apiStore from './api-state'
export default configureStore({
    reducer: {
        projectStore,
        userStore,
        modalsStore,
        drawerStore,
        connectStore,
        apiStore
    }
})